export default __webpack_public_path__ + "not-found-graphic.png";